import {ElasticParser, ElasticSearchProperty} from '../factory.parsers';
import {buildQueryRegex, buildQueryTermEqual} from '../../query/elastic.queries';

const parseReservedCharacters = (text: string): string => text.replace(/\*/g, '.*').replace(/\?/g, '.');
const escapeReservedCharacters = (text: string): string => text.replace(/[-\/\\^$+.()[\]{}]/g, '\\$&').replace(/\&/g, '\\&');
const removeDoubleQuotes = (text: string): string => text.replace(/"/g, '');
const addAnyCharacterRegexAsPrefixAndSuffix = (text: string): string => `.*${text}.*`;
const collapseBlankSpaces = (text: string): string => text.replace(/\s{2,}/g, ' ');
const collapseStarCharacters = (text: string): string => text.replace(/(\.\*){2,}/g, '.*');
const convertToCaseIgnoringRegex = (text: string): string => {
  let result = '';

  for (const char of text) {
    result += char.match(/[a-z]/i) ? `[${char.toLowerCase()}${char.toUpperCase()}]` : char;
  }

  return result;
};

export class RegexParser implements ElasticParser {
  parseValue(regexsString: string, elasticSearchProperty: ElasticSearchProperty): any {
    const {property} = elasticSearchProperty;

    const regexsQueries = regexsString?.split('|')
      .map(regexString => regexString.trim())
      .filter(regexString => !!regexString)
      .map(regexString => {
        const isRegexStringSurroundedByQuotes = (regexString[0] === '"' && regexString[regexString.length - 1] === '"');

        if (isRegexStringSurroundedByQuotes) {
          return buildQueryTermEqual(property, regexString.slice(1, -1));
        } else {
          return [regexString]
            .map(escapeReservedCharacters)
            .map(parseReservedCharacters)
            .map(addAnyCharacterRegexAsPrefixAndSuffix)
            .map(removeDoubleQuotes)
            .map(collapseBlankSpaces)
            .map(collapseStarCharacters)
            .map(convertToCaseIgnoringRegex)
            .map(regex => buildQueryRegex(property, regex))[0];
        }
      });

    if (regexsQueries?.length > 0) {
      return {bool: {should: regexsQueries}};
    } else {
      return undefined;
    }
  }
}
